import React from "react";
import { CompetitorComparisonHeroSection } from "@tennr/frontend/sections/CompetitorComparisonHeroSection";
import { BookFeaturesSection } from "@tennr/frontend/sections/BookFeaturesSection";
import { BookTestimonialsSection } from "@tennr/frontend/sections/BookTestimonialsSection";
import { BookCtaSection } from "@tennr/frontend/sections/BookCtaSection";
import "@tennr/style/index.css";
import "./CompetitorComparisonPage.css";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import { useLoaderData } from "@tanstack/react-router";

export const CompetitorComparisonPage: React.FC = () => {
  const competitor = useLoaderData({ from: "/_app/lp/$competitorId" }).competitorId;
  return (
    <>
      <MetadataTags
        title="Book a Demo | Tennr"
        description="Find a time to see how Tennr can help you convert more patients and reduce denials with fewer resources."
        imageUrl="https://tennr.com/share_cards/sharecard.png"
      />
      <meta name="robots" content="noindex" />
      <main className="competitor-comparison-page">
        <PageBackground bgImage="/img/book-demo-hero-bg.jpg" bgImageVert="/img/book-demo-hero-bg-vert.jpg" />
        <CompetitorComparisonHeroSection competitor={competitor} />
        <BookTestimonialsSection />
        <BookCtaSection />
      </main>
      <SiteFooter taglinePosition="left" bgImage="/img/footer-demo-bg.jpg" bgImageVert="/img/footer-demo-bg-vert.jpg" />
    </>
  );
};
